import PreviewNFTCard from "../card/PreviewNFTCard"
import { DialogActions, Grid, Stack } from "@mui/material"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import React from "react"
import { useNavigate } from "react-router-dom"
import { BASE_URL } from "../../constants/constants"
import { PATHS } from "../../constants/paths"
import coins from "../../assets/img/coins_1.png"

const ZealyRewardDialog = ({ item, amount, closeDialog }) => {
  const navigate = useNavigate()

  const maxWidth = 500

  return (
    <Box
      sx={{
        maxWidth,
        background: "#121212",
        textAlign: "center",
      }}
    >
      <DialogTitle sx={{ fontSize: "1rem", position: "relative", pr: 6 }}>
        Congratulations, Zealy Campaign Winner!
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 0, fontSize: "16px !important" }}>
        <Typography mb={2} sx={{ whiteSpace: "pre-wrap" }}>
          You successfully completed the Zombie TD Zealy Campaign and secured a
          place among the top 30% of participants 🧟‍♂️
        </Typography>
        <Grid container spacing={2} sx={{ justifyContent: "center" }}>
          <Grid item md={6}>
            <Typography mb={2}>Your reward:</Typography>
            <>
              {item ? (
                <PreviewNFTCard
                  imageUrl={BASE_URL + item.image}
                  videoUrl={BASE_URL + item.video}
                  id={item.id}
                  lvl={item.level}
                  rarity={item.rarity}
                  type={item.type}
                />
              ) : (
                <>
                  <img src={coins} alt="Coins" style={{ width: "65%" }} />
                  <Typography variant="h4">{amount} ZTD</Typography>
                </>
              )}
            </>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 3, width: "100%", justifyContent: "center" }}>
        <Stack flexWrap="wrap" direction="horizontal" useFlexGap spacing={1}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              closeDialog()
              navigate(PATHS.ACCOUNT.PATH)
            }}
            sx={{ fontFamily: "RUSBoycott, sans-serif" }}
          >
            Go to Dashboard
          </Button>
        </Stack>
      </DialogActions>
    </Box>
  )
}
export default ZealyRewardDialog
